// extracted by mini-css-extract-plugin
export default {"container":"HeaderContainerBorderless-module--container--5X8vZ"};